import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import toastr from "../../../components/elements/toast";
import { setShowAssets } from "../../../Redux/Slices/MainSlice";
import httpApiCall from "../../../service/api.service";
import { getStorageValue } from "../../../service/shared.service";
import "./Delete.scss"

const Delete = (props: any) => {
  const [sppiner, setSppiner] = useState(false);
  const profileData = getStorageValue("partnerProfile");
  const toastrService = new toastr(true);
  const dispatch = useDispatch();

  const deleteFile = () => {
    const body = {
      access_token: profileData[0].access_token,
      partner_id: profileData[0].partner_id,
      type: props.fileType,
      assets_file_id: props.fileId,
    };
    setSppiner(true);
    httpApiCall({ api: "delete_assets_file", type: "post", body })
      .then((response) => {
        setSppiner(false);
        if (response && response.is_error == 0) {
          props.onHide();
          if (props.fileId) {
            dispatch(setShowAssets(false));
            props.getallfilesdata(props.folderId,1);
            if (props.folderType && props.navigateToHome) {
              props.getFolders();
            }
          }
          toastrService.showSuccess("Deleted Successfully");
          return;
        } else {
          toastrService.showError(response.err);
        }
      })
      .catch((error) => {
        toastrService.showError(error);
      });
  };
  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="userflow-input">
            <p>Are you sure you would like to delete the folder?</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="mb-3">
          <Button variant="secondary" onClick={props.onHide} className="button cancel button-font">
            Cancel
          </Button>
          <Button disabled={sppiner} variant="primary" onClick={deleteFile}>
            Delete
            {sppiner && (
              <Spinner
                className="ml-2"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Delete;
